<script setup lang="ts"></script>

<template>
  <v-row class="fill-height" no-gutters>
    <v-col>
      <slot></slot>
    </v-col>
  </v-row>
</template>